/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs */



/**
* | output |
* | --- |
* | "Toggle Forced Narrative Subtitles" |
*
* @param {Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_forced_narrative_subtitles = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Forced_Narrative_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer les sous-titres narratifs forces")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erzwungene narrative Untertitel ein-/ausschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva i sottotitoli narrativi forzati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить/выключить принудительные субтитлы с повествованием")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar subtítulos narrativos forzados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换强制叙述字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("強制字幕のオン/オフ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनिवार्य कथात्मक उपशीर्षक चालू/बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar/Desativar legendas narrativas forçadas")
	return /** @type {LocalizedString} */ ("Toggle Forced Narrative Subtitles")
});